export default __webpack_public_path__ + "static/media/despacho_zwolf_logo_large.8341716a.png";